export const ProductAttributes = {
    data: [],
};

let productAttributeName = [
    "Absorption Quality",
    "Accessbility",
    "Age/Gender Groups",
    "Ambience",
    "Anti-Aging Properties",
    "Authentication/Authorization",
    "Booking/Cancellation",
    "Cleanliness/Hygiene",
    "Customer Service",
    "Damage/Defect",
    "Easy of Use",
    "Expiry Period",
    "Facilities",
    "Suggestions/Feedback",
    "Flavour/Taste",
    "Free From",
    "Freshness",
    "General Order Issues",
    "Holistic",
    "Installation",
    "Instore Experience",
    "Interest Rates",
    "Quantity/Missing Items",
    "Moisturization Quality",
    "Multifunctionality",
    "Natural/Sustainable",
    "Network Coverage",
    "Noise",
    "Packaging",
    "Policy Coverage",
    "Pricing",
    "Appearance",
    "Authenticity",
    "Availability",
    "Color",
    "Product Efficacy",
    "Smell",
    "Ingredients",
    "Leakage",
    "Durability",
    "Product Performance/Quality",
    "Reliability",
    "Product Side Effects",
    "Size/Fit",
    "Texture/Material",
    "Return/Exchange",
    "Safety",
    "Shipping/Delivery",
    "Spaciousness",
    "Storage ",
    "Streaming Issues",
    "Subscription",
    "Sustainability",
    "Technical Issues",
    "Warranty",
    "Water Resistance",
    "Website/App Experience",
    "Whitening/Brightening",
    "Satisfaction",
    "Comfort",
    "Purchase Intent",
    "Brand Loyalty",
    "Recommendation",
    "Label Instructions",
    "Weight",
    "Functionality/Customization",
    "Story/Concept",
    "Cast/Characters",
    "Workplace Experience",
    "Audio/Video Quality",
    "Piracy",
    "Payment/Billing ",
    "Content Quality",
    "Diversity & Inclusivity",
    "Show Release",
    "Collection/Variety",
    "Quantity/Missing Items",
    "Repair",
    "Unusual Activity/Hacking ",
    "Notifications",
    "Marketing and Advertising",
    "Algorithm",
    "Reward Points & Cashbacks",
    "Technical Updates/New Updates",
    "Parking",
];
let categoryName = [
    "ABSORPTION_QUALITY",
    "ACCESSIBILITY",
    "AGE_GENDER_GROUPS",
    "AMBIENCE",
    "ANTI_AGING",
    "AUTHENTICATION_LOGIN",
    "BOOKING_CANCELLATION_ENQUIRIES",
    "CLEANLINESS_HYGIENE",
    "CUSTOMER_SERVICE",
    "DAMAGED_DEFECTIVE_PRODUCT",
    "EASE_OF_USE",
    "EXPIRY_TIME",
    "FACILITIES",
    "FEEDBACK",
    "FLAVOUR_TASTE",
    "FREE_FROM",
    "FRESHNESS",
    "GENERAL_ORDER_ISSUES",
    "HOLISTIC",
    "INSTALLATION",
    "INSTORE_EXPERIENCE",
    "INTEREST_RATES",
    "MISSING_PARTS_QUANTITY",
    "MOISTURIZATION_DRYNESS",
    "MULTIFUNCTIONAL",
    "NATURAL",
    "NETWORK_COVERAGE",
    "NOISE",
    "PACKAGING",
    "POLICY_COVERAGE",
    "PRICING",
    "PRODUCT_APPEARANCE",
    "PRODUCT_AUTHENTICITY",
    "PRODUCT_AVAILABILITY",
    "PRODUCT_COLOR",
    "PRODUCT_EFFICACY_ON_SKIN",
    "PRODUCT_FRAGRANCE",
    "PRODUCT_INGREDIENTS",
    "PRODUCT_LEAK",
    "PRODUCT_LIFE_DURABILITY",
    "PRODUCT_PERFORMANCE_QUALITY",
    "PRODUCT_RELIABILITY",
    "PRODUCT_SIDE_EFFECTS",
    "PRODUCT_SIZE",
    "PRODUCT_TEXTURE",
    "RETURN_EXCHANGE_REFUND",
    "SAFETY",
    "SHIPPING_DELIVERY",
    "SPACIOUSNESS",
    "STORAGE_MEMORY",
    "STREAMING_ISSUES",
    "SUBSCRIPTION_MEMBERSHIP",
    "SUSTAINABILITY",
    "TECHNICAL_ISSUES",
    "WARRANTY",
    "WATER_RESISTANCE",
    "WEBSITE_APP_EXPERIENCE",
    "WHITENING_BRIGHTENING",
    "SATISFACTION",
    "COMFORT",
    "PURCHASE_INTENT",
    "LOYALTY",
    "RECOMMENDATION",
    "LABELLING_INSTRUCTIONS",
    "WEIGHT",
    "FUNCTIONALITY_CUSTOMIZATION",
    "STORY_PLOT",
    "CHARACTERS",
    "WORK PLACE_EXPERIENCE",
    "AUDIO_VIDEO_QUALITY",
    "PIRACY",
    "PAYMENT_BILLING",
    "CONTENT",
    "DIVERSITY_INCLUSIVITY",
    "SHOW_RELEASE",
    "COLLECTIONS/VARIETY",
    "QUANTITY",
    "REPAIR",
    "UNUSUAL ACTIVITY/HACKING",
    "NOTIFICATIONS",
    "MARKETING AND ADVERTISING",
    "ALGORITHM",
    "REWARD POINTS & CASHBACKS",
    "PARKING",
    "TECHNICAL UPDATES/NEW UPDATES",
];

for (let i = 0; i < categoryName.length; i++) {
    let object = {};
    object.attributeName = productAttributeName[i];
    object.categoryName = categoryName[i];
    ProductAttributes.data.push(object);
}
